"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserFacingDownPaymentDollars = exports.getUserFacingDownPaymentFromDollars = void 0;
const homePurchaseSlider_1 = require("./homePurchaseSlider");
/**
 * The borrower-facing full down payment: the portion still due at close plus the earnest money deposit
 * already paid toward it.
 */
const getUserFacingDownPaymentFromDollars = ({ downPaymentDollars, earnestMoneyDepositDollars }) => downPaymentDollars + earnestMoneyDepositDollars;
exports.getUserFacingDownPaymentFromDollars = getUserFacingDownPaymentFromDollars;
/** The same full down payment for an offer's terms, whose down payment carries only the still-due portion. */
const getUserFacingDownPaymentDollars = (homePurchaseTerms) => (0, exports.getUserFacingDownPaymentFromDollars)({
    downPaymentDollars: (0, homePurchaseSlider_1.getCalculatedAmountDollars)(homePurchaseTerms.downPaymentTerms),
    earnestMoneyDepositDollars: homePurchaseTerms.earnestMoneyDeposit,
});
exports.getUserFacingDownPaymentDollars = getUserFacingDownPaymentDollars;
